import React, { FC, useState, useEffect } from 'react';
import styles from './styles.module.css';
import { CachedIcon, Asset } from '@clearcover/atlas';

export const RefreshTimer: FC<{ refresh: () => void }> = ({ refresh }) => {
  const [timer, setTimer] = useState('less than a minute ago');
  const [buttonActive, setButtonActive] = useState(false);

  const start = Date.now();

  const getTime = () => {
    const time = start - Date.now();
    const minutes = Math.floor(time / 1000 / 60);

    if (minutes === -1) {
      setTimer('less than a minute ago');
    } else if (minutes < -60) {
      setTimer('over an hour ago');
    } else {
      if (!buttonActive) {
        setButtonActive(true);
      }
      setTimer(
        `${Math.abs(minutes + 1)} minute${minutes === -2 ? '' : 's'} ago`
      );
    }
  };

  useEffect(() => {
    const interval = setInterval(() => getTime(), 60000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.lastUpdated}>
      {!buttonActive && (
        <Asset
          className={styles.refreshIconInactive}
          icon={CachedIcon}
          height={20}
          width={20}
          description="Refresh"
        />
      )}
      {buttonActive && (
        <button
          data-testid="rewards-portal-refresh-points"
          title="Refresh"
          onClick={() => {
            setButtonActive(false);
            refresh();
          }}
        >
          <Asset
            className={styles.refreshIconActive}
            icon={CachedIcon}
            height={20}
            width={20}
            description="Refresh"
          />
        </button>
      )}
      <div>Last updated: {timer}</div>
    </div>
  );
};
